<template>
    <div>
        <div v-if="order">
            <section class="p-0 opr_status_sec">
                <div class="container">
                    <div class="row">
                        <div class="col-md-4 col-lg-4 col-xl-3">
                            <div class="opr_order_id">
                                <h1 class="heading2">
                                    Order
                                    <span>#{{ order.unique_order_id }}</span>
                                </h1>
                            </div>
                        </div>
                        <div class="col-md-8 col-lg-8 col-xl-5">
                            <div class="opr_status d-flex">
                                <h2 class="heading2 font-weight-bold">
                                    <span class="font-weight-normal"
                                        >Status</span
                                    >
                                </h2>
                                <div class="select_option">
                                    <h2
                                        class="heading2 font-weight-bold"
                                        v-if="
                                            order.NewOrderItems[current_index]
                                                .order_review_items[version - 1]
                                                .status != 'APPROVED'
                                        "
                                    >
                                        On hold awaiting Approval
                                    </h2>
                                    <h2
                                        class="heading2 font-weight-bold text-success"
                                        v-else
                                    >
                                        Approved
                                    </h2>
                                    <v-select
                                        class="no-print"
                                        v-if="
                                            order.NewOrderItems[
                                                current_index
                                            ].order_review_items.filter(
                                                (review_item) =>
                                                    review_item.status !=
                                                    'APPROVED'
                                            ).length > 0
                                        "
                                        label="version_id"
                                        @input="onChangeVersionApproval"
                                        :reduce="(item) => item.version_id"
                                        :options="
                                            order.NewOrderItems[
                                                current_index
                                            ].order_review_items.filter(
                                                (review_item) =>
                                                    review_item.status !=
                                                    'APPROVED'
                                            )
                                        "
                                        :placeholder="
                                            order.NewOrderItems[
                                                current_index
                                            ].order_review_items.filter(
                                                (review_item) =>
                                                    review_item.status !=
                                                    'APPROVED'
                                            ).length + ' more approval pending'
                                        "
                                    >
                                        <template
                                            slot="selected-option"
                                            slot-scope="option"
                                        >
                                            {{ option.version_id }} approval
                                            pending
                                        </template>
                                        <template v-slot:option="option">
                                            <span :class="option.icon"></span>
                                            {{ option.version_id }} approval
                                            pending
                                        </template>
                                    </v-select>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12 col-lg-12 col-xl-4">
                            <div class="opr_note">
                                <p class="secondary_light_grey m-0">
                                    <b class="secondary_black">Note:</b> Changes
                                    or Delayed approval may result in extended
                                    production time and or additional
                                    artwork/proof charges
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section class="p-0 opr_items_no_sec">
                <div class="container">
                    <div class="row align-items-center">
                        <div class="col-md-12 col-lg-12 col-xl-6">
                            <div
                                class="opr_items_no d-flex align-items-center flex-wrap"
                            >
                                <h3 class="heading4 mb-0 items_no_h3">
                                    Item #
                                    <span>
                                        {{
                                            order.NewOrderItems[current_index]
                                                .product_number
                                        }}</span
                                    >
                                </h3>
                                <h3 class="heading4 mb-0 items_name_h3">
                                    {{
                                        order.NewOrderItems[current_index].name
                                    }}
                                </h3>
                                <h3 class="heading4 mb-0 items_update_h3">
                                    Updated Proof:
                                    {{
                                        new Date(
                                            order.NewOrderItems[
                                                current_index
                                            ].order_review_items[
                                                version - 1
                                            ].updated_at
                                        ).toLocaleDateString("es-CL")
                                    }}
                                </h3>
                            </div>
                        </div>
                        <div class="col-md-12 col-lg-12 col-xl-6">
                            <div
                                class="d-flex align-items-center justify-content-end"
                            >
                                <div
                                    class="opr_approvel_right_box d-flex align-items-center"
                                >
                                    <div
                                        :class="`opr_approvel_space_box ${
                                            current_index == index
                                                ? 'active'
                                                : ''
                                        }`"
                                        style="cursor: pointer"
                                        v-for="(
                                            item, index
                                        ) in order.NewOrderItems.slice(
                                            0,
                                            remaining_from
                                        )"
                                        :key="index"
                                    >
                                        <div
                                            class="opr_approvel_img_box cursor-pointer"
                                            @click="onSelectReviewItem(index)"
                                        >
                                            <p>
                                                <img
                                                    :src="
                                                        item.product_image
                                                            .thumbnail
                                                    "
                                                    alt=""
                                                />
                                            </p>
                                            <h3>{{ item.name }}</h3>
                                        </div>
                                    </div>
                                </div>

                                <div
                                    class="opr_approvel_order_box no-print"
                                    v-if="
                                        order.NewOrderItems.slice(
                                            remaining_from
                                        ).length > 0
                                    "
                                >
                                    <div
                                        class="dropdown"
                                        id="opr_dropdown_toggle_custom"
                                    >
                                        <a
                                            href="javascript:void(0)"
                                            id="opr_approvel_order"
                                            @click="orderFunction()"
                                        >
                                            +{{
                                                order.NewOrderItems.slice(
                                                    remaining_from
                                                ).length
                                            }}
                                        </a>
                                        <div class="dropdown-menu">
                                            <h4 class="font_size_24 mb_30">
                                                All products requiring approval
                                                on this order:
                                            </h4>
                                            <div class="dropdown-item p-0">
                                                <div
                                                    class="opr_approvel_product_drop d-flex cursor-pointer"
                                                    @click="
                                                        onSelectRemainingItem(
                                                            index + 3
                                                        )
                                                    "
                                                    style="cursor: pointer"
                                                    v-for="(
                                                        item, index
                                                    ) in order.NewOrderItems.slice(
                                                        remaining_from
                                                    ).filter(
                                                        (item) =>
                                                            item.order_review_items
                                                    )"
                                                    :key="index"
                                                >
                                                    <div
                                                        class="opr_approvel_product_drop_img mr_16"
                                                    >
                                                        <span>
                                                            <img
                                                                :src="
                                                                    item
                                                                        .product_image
                                                                        .thumbnail
                                                                "
                                                                alt=""
                                                            />
                                                        </span>
                                                    </div>
                                                    <div
                                                        class="opr_approvel_product_drop_content"
                                                    >
                                                        <h4
                                                            class="d-flex justify-content-between mb_0"
                                                        >
                                                            {{ item.name }}
                                                            <!-- <span>{{ new Date(item.order_review_items[version-1].updated_at).toLocaleDateString() }}</span> -->
                                                        </h4>
                                                        <p class="mb_10">
                                                            Total Quantity:
                                                            <b class="ml_4">{{
                                                                parseInt(
                                                                    item.total_quantity
                                                                )
                                                            }}</b>
                                                        </p>
                                                        <p class="mb_10">
                                                            Base Price:
                                                            <b class="ml_4"
                                                                >${{
                                                                    parseFloat(
                                                                        item.total_price
                                                                    ).toFixed(2)
                                                                }}</b
                                                            >
                                                        </p>
                                                        <p class="mb_10">
                                                            Total Item Fee:
                                                            <b class="ml_4">
                                                                ${{
                                                                    (
                                                                        item.total_quantity *
                                                                        item
                                                                            .order_review_items[0]
                                                                            .total_decoration_fee
                                                                    ).toFixed(2)
                                                                }}
                                                            </b>
                                                        </p>
                                                        <p class="mb_10">
                                                            Total Order Fee:
                                                            <b
                                                                class="ml_4"
                                                                v-if="
                                                                    order
                                                                        .OrderReviewFee
                                                                        .decoration_fee
                                                                "
                                                                >${{
                                                                    (
                                                                        item.total_quantity *
                                                                        parseFloat(
                                                                            order
                                                                                .OrderReviewFee
                                                                                .decoration_fee
                                                                        )
                                                                    ).toFixed(2)
                                                                }}</b
                                                            >
                                                            <b
                                                                class="ml_4"
                                                                v-else
                                                                >$0.00</b
                                                            >
                                                        </p>
                                                        <p class="mb_10">
                                                            Grand Total:
                                                            <b class="ml_4"
                                                                >${{
                                                                    showGrandTotalPrice(
                                                                        item
                                                                    )
                                                                }}</b
                                                            >
                                                        </p>
                                                        <p
                                                            class="on_hold status_custom_box mb_0"
                                                        >
                                                            In Review
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section class="opr_version_image_sec pb-0">
                <div class="container">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="opr_version_select">
                                <div class="select_option m-0">
                                    <v-select
                                        style="width: 10%"
                                        label="version_id"
                                        v-model="version"
                                        :clearable="false"
                                        :reduce="(item) => item.version_id"
                                        :options="
                                            order.NewOrderItems[current_index]
                                                .order_review_items
                                        "
                                    >
                                        <template
                                            slot="selected-option"
                                            slot-scope="option"
                                        >
                                            Version {{ option.version_id }}
                                        </template>
                                        <template v-slot:option="option">
                                            <span :class="option.icon"></span>
                                            Version {{ option.version_id }}
                                        </template>
                                    </v-select>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12 col-lg-12 col-xl-8">
                            <div class="opr_version_img text-center mt_40">
                                <img
                                    :src="
                                        order.NewOrderItems[current_index]
                                            .order_review_items[version - 1]
                                            .artwork
                                    "
                                    alt=""
                                />
                            </div>

                            <div class="opr_version_img_download mt_34">
                                <h1 class="heading4 no-print">Download</h1>
                                <div
                                    class="no-print opr_download_btns d-flex justify-content-between flex-wrap"
                                >
                                    <div>
                                        <!-- <a href="javascript:window.print();" class="btn btn_outline_primary border_primary_blue text_primary_blue mr_22">
                                            <img src="/maincss/images/icons/document.svg" alt="" />
                                            PDF</a> -->
                                        <a
                                            :href="
                                                order.NewOrderItems[
                                                    current_index
                                                ].order_review_items[
                                                    version - 1
                                                ].artwork
                                            "
                                            class="btn btn_outline_primary border_primary_blue text_primary_blue mr_22"
                                            download
                                            target="_blank"
                                        >
                                            <img
                                                src="/maincss/images/icons/picture.svg"
                                                alt=""
                                            />
                                            Image</a
                                        >
                                    </div>
                                </div>

                                <div class="opr_product_style mt_40">
                                    <p>
                                        <span>Product Style: </span>
                                        {{
                                            order.NewOrderItems[current_index]
                                                .product_number
                                        }}
                                    </p>
                                    <p class="d-flex align-items-center">
                                        <span class="mr_6"
                                            >Product Color:
                                        </span>
                                        <img
                                            class="mr-1"
                                            :style="'border:1px solid #c5c2c2;min-width:30px;height:30px;'"
                                            v-if="
                                                order.NewOrderItems[
                                                    current_index
                                                ].color.swatches
                                            "
                                            :src="
                                                order.NewOrderItems[
                                                    current_index
                                                ].color.swatches
                                            "
                                        />
                                        <span
                                            class="mr-1"
                                            v-else
                                            :style="`border:1px solid #c5c2c2;min-width:30px;height:30px;background: ${order.NewOrderItems[current_index].color.hex};`"
                                        ></span>
                                        {{
                                            order.NewOrderItems[current_index]
                                                .color.name
                                        }}
                                    </p>
                                    <p>
                                        <span>Product Sizes: </span>
                                        {{
                                            order.NewOrderItems[
                                                current_index
                                            ].sizes
                                                .map(
                                                    (sub_product) =>
                                                        sub_product
                                                            .NewSubProduct.Size
                                                            .size
                                                )
                                                .join(",")
                                        }}
                                    </p>
                                    <div
                                        v-for="(
                                            location, location_index
                                        ) in order.NewOrderItems[current_index]
                                            .imprint_locations"
                                        :key="location_index"
                                    >
                                        <p v-if="location.colors.length > 0">
                                            <span class="mr_6"
                                                >Imprint Location:
                                            </span>
                                            {{ location.location }}
                                        </p>

                                        <p
                                            class="d-flex align-items-center"
                                            v-for="(
                                                colors, color_key
                                            ) in location.colors"
                                            :key="color_key"
                                        >
                                            <span class="mr_6"
                                                >Color {{ color_key + 1 }}:
                                            </span>
                                            <span
                                                class="mr-1"
                                                :style="`border:1px solid #c5c2c2;min-width:30px;height:30px;background: ${colors.color.color_value};`"
                                            ></span>
                                            {{ colors.color.color_name }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="no-print col-md-12 col-lg-12 col-xl-4">
                            <div class="opr_product_color_approve_box">
                                <!--  it’s approved start -->
                                <div
                                    class="opr_its_approved_box_custom"
                                    v-if="
                                        order.NewOrderItems[current_index]
                                            .order_review_items[version - 1]
                                            .status == 'APPROVED'
                                    "
                                >
                                    <p class="mb-0">
                                        <img
                                            src="/maincss/images/icons/green_check.svg"
                                            alt=""
                                            class="mr_8"
                                        />
                                        it’s approved
                                    </p>
                                </div>
                                <!--  it’s approved End -->

                                <h2
                                    class="heading4 mb_38"
                                    v-if="
                                        order.NewOrderItems[current_index]
                                            .vendor_colors.length > 0
                                    "
                                >
                                    Product colors to approve
                                </h2>

                                <div
                                    v-for="(location, location_index) in order
                                        .NewOrderItems[current_index]
                                        .imprint_locations"
                                    :key="location_index"
                                >
                                    <div
                                        class="d-flex opr_pro_color_approve_content"
                                        v-for="(
                                            color, color_index
                                        ) in location.colors"
                                        :key="color_index"
                                    >
                                        <div>
                                            <span
                                                class="opr_color_box"
                                                :style="
                                                    'background: ' +
                                                    color.color.color_value
                                                "
                                            ></span>
                                        </div>
                                        <div>
                                            <h5 class="heading5 mb-0">
                                                {{ color.color.color_name }}
                                            </h5>
                                            <p class="font_size_14 mb-0">
                                                Ink color:
                                                {{
                                                    color.color.category
                                                        ? color.color.category
                                                        : ""
                                                }}
                                            </p>
                                            <p class="font_size_14 mb-0">
                                                Location:
                                                {{ location.location }}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="opr_note_pro_approv mt_30">
                                    <p class="mb_0">
                                        <b>Note:</b> Artwork can only be
                                        approved or modified by the person who
                                        orders.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- version image section end -->

            <section class="p-0">
                <div class="container">
                    <div class="row">
                        <div class="col-md-12 col-lg-12 col-xl-8">
                            <div class="opr_proof_carefilly">
                                <p>
                                    These designs are property of Imprint City
                                    and may not be reproduced in any way without
                                    permission from Imprint City.
                                </p>
                                <div class="opr_carefully_box text-center">
                                    <h2 class="heading4 font-weight-bold mb_14">
                                        Please Proof Carefully
                                    </h2>
                                    <p class="mb-0">
                                        Check spelling, content, color, imprint
                                        size and location. Placement, size and
                                        color are approximations and may look
                                        different on your screen. We are not
                                        responsible for errors noticed after
                                        your approval. Changes made after
                                        approval may result in additional fees &
                                        delays. An email reply referencing the
                                        design will be considered an approval
                                        unless changes are specified.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>

        <div class="preloader" v-show="isLoader">
            <div class="preloader-body">
                <svg width="40" height="40" viewBox="0 0 40 40">
                    <polygon
                        class="rect"
                        points="0 0 0 40 40 40 40 0"
                    ></polygon>
                </svg>
            </div>
        </div>
    </div>
</template>

<script>
import ApiService from "@/common/api.service";
export default {
    data() {
        return {
            order: null,
            current_index: 0,
            version: 1,
            isLoader: false,
            attachment: "",
            remaining_from: 3,
            approved: false
        };
    },
    mounted() {
        this.getOrderDetail();
    },
    methods: {
        orderFunction() {
            this.prepareRemainingItemFees();
            var element = document.getElementById("opr_dropdown_toggle_custom");
            element.classList.toggle("opr_approvel_order_toggle");
        },
        prepareRemainingItemFees() {
            for (
                let i = this.remaining_from;
                i <= this.order.NewOrderItems.length - 1;
                i++
            ) {
                let OrderReviewFees = this.order.OrderReviewFees.filter(
                    (review_fee) =>
                        review_fee.OrderReviewItem != null &&
                        review_fee.OrderReviewItem.product_id ==
                            this.order.NewOrderItems[i].id &&
                        review_fee.OrderReviewItem.color_id ==
                            this.order.NewOrderItems[i].color.id &&
                        review_fee.OrderReviewItem.size_group_id ==
                            this.order.NewOrderItems[i].gender_size_id &&
                        review_fee.OrderReviewItem.unique_item_id ==
                            this.order.NewOrderItems[i].unique_item_id &&
                        review_fee.OrderReviewItem.version_id == 1
                );
                let total_decoration_fee = 0;
                OrderReviewFees.forEach((review_fee) => {
                    total_decoration_fee += parseFloat(
                        review_fee.decoration_fee
                    );
                });
                this.order.NewOrderItems[i].order_review_items = [
                    { OrderReviewFees, total_decoration_fee }
                ];
            }
            this.$forceUpdate();
        },
        getOrderDetail() {
            var _this = this;
            _this.isLoader = true;
            new Promise((resolve, reject) => {
                ApiService.get(`/order-proof-review/${this.$route.params.id}`)
                    .then(async ({ data }) => {
                        let order = data.order;
                        let order_items = [];
                        let all_setup_fee = 0;
                        let order_review_items =
                            data.order_review_master.OrderReviewItems;
                        for (let item of data.order.NewOrderItems) {
                            let review_items = order_review_items.filter(
                                (review_item) =>
                                    review_item.product_id ==
                                        item.NewSubProduct.parent_product_id &&
                                    review_item.color_id ==
                                        item.NewSubProduct.color_id &&
                                    review_item.size_group_id ==
                                        item.gender_size_id &&
                                    review_item.unique_item_id ==
                                        item.unique_item_id
                            );
                            if (review_items.length == 0) {
                                continue;
                            }
                            let item_setup_fee = 0;
                            let order_item = item.NewSubProduct.NewProduct;
                            order_item.gender_size_id = item.gender_size_id;
                            order_item.unique_item_id = item.unique_item_id;
                            order_item.color = item.NewSubProduct.Color;
                            order_item["NewOrderItemDecoration"] =
                                item.NewOrderItemDecoration;
                            let index = order_items.findIndex(
                                (item_data) =>
                                    item_data.id ==
                                        item.NewSubProduct.parent_product_id &&
                                    item_data.color.id ==
                                        item.NewSubProduct.color_id &&
                                    item_data.gender_size_id ==
                                        item.gender_size_id &&
                                    item_data.unique_item_id ==
                                        item.unique_item_id
                            );
                            item_setup_fee =
                                item_setup_fee + parseFloat(item.setup_fee);
                            if (index >= 0 && order_items[index]) {
                                order_items[index]["sizes"].push(item);
                                order_items[index]["total_quantity"] +=
                                    item.quantity;
                                order_items[index]["total_price"] +=
                                    parseFloat(item.total_price) +
                                    parseFloat(item.setup_fee);
                            } else {
                                order_item["sizes"] = [item];
                                order_item["total_quantity"] = item.quantity;
                                order_item["total_price"] =
                                    parseFloat(item.total_price) +
                                    parseFloat(item.setup_fee);
                                order_item["setup_fee"] = item_setup_fee;
                                order_item["order_review_items"] = review_items;
                                order_item["imprint_locations"] = JSON.parse(
                                    item.imprint_locations
                                );
                                order_item["product_image"] =
                                    order_item.NewProductImages.find(
                                        (image) =>
                                            image.color_id ==
                                            order_item.color.id
                                    );
                                if (!order_item["product_image"]) {
                                    order_item["product_image"] =
                                        order_item.NewProductImages[0];
                                }
                                let vendor_colors = [];
                                if (item.imprint_locations) {
                                    JSON.parse(item.imprint_locations).forEach(
                                        (location) => {
                                            location.colors.forEach((color) => {
                                                let exist = vendor_colors.find(
                                                    (data) =>
                                                        data.color.color_id ==
                                                        color.color.color_id
                                                );
                                                if (!exist) {
                                                    vendor_colors.push(color);
                                                }
                                            });
                                        }
                                    );
                                }
                                order_item["vendor_colors"] = vendor_colors;

                                order_items.push(order_item);
                            }
                            all_setup_fee = all_setup_fee + item_setup_fee;
                        }

                        await this.getSingleOrderReview(
                            order_items[this.current_index]
                        );

                        order.total_setup_fee = all_setup_fee;
                        order.NewOrderItems = order_items;
                        order.OrderReviewFee = order.OrderReviewFees.find(
                            (review_fee) =>
                                review_fee.order_review_item_id == null
                        );
                        if (!order.OrderReviewFee) {
                            order.OrderReviewFee = { decoration_fee: 0.0 };
                        }
                        _this.order = order;
                        _this.isLoader = false;
                        resolve(data);
                    })
                    .catch((err) => {
                        console.log(err);
                        _this.isLoader = false;
                        reject(err);
                    });
            });
        },
        onSelectReviewItem(index) {
            if (index == this.current_index) {
                return;
            }
            this.version = 1;
            this.isLoader = true;
            this.getSingleOrderReview(this.order.NewOrderItems[index])
                .then(() => {
                    this.current_index = index;
                    this.isLoader = false;
                })
                .catch(() => {
                    this.isLoader = false;
                });
        },
        onSelectRemainingItem(index) {
            this.version = 1;
            this.isLoader = true;
            this.getSingleOrderReview(this.order.NewOrderItems[index])
                .then(() => {
                    this.current_index = 0;
                    [
                        this.order.NewOrderItems[0],
                        this.order.NewOrderItems[index]
                    ] = [
                        this.order.NewOrderItems[index],
                        this.order.NewOrderItems[0]
                    ];
                    this.orderFunction();
                    this.isLoader = false;
                })
                .catch(() => {
                    this.isLoader = false;
                });
        },
        getSingleOrderReview(order_item) {
            let params = {
                unique_item_id: order_item.unique_item_id,
                order_id: this.$route.params.id,
                size_group_id: order_item.gender_size_id,
                color_id: order_item.color.id,
                product_id: order_item.id
            };
            return new Promise((resolve, reject) => {
                ApiService.post("/order-review", params)
                    .then(({ data }) => {
                        order_item["order_review_items"] =
                            data.order_review_master.OrderReviewItems.filter(
                                (review_item) =>
                                    review_item.product_id == order_item.id &&
                                    review_item.color_id ==
                                        order_item.color.id &&
                                    review_item.size_group_id ==
                                        order_item.gender_size_id &&
                                    review_item.unique_item_id ==
                                        order_item.unique_item_id
                            );
                        order_item["order_review_items"].forEach(
                            (review_item) => {
                                review_item.total_decoration_fee = 0;
                                review_item.OrderReviewFees.forEach(
                                    (decoration) => {
                                        review_item.total_decoration_fee +=
                                            parseFloat(
                                                decoration.decoration_fee
                                            );
                                    }
                                );
                            }
                        );
                        this.approved =
                            order_item.order_review_items[this.version - 1]
                                .status == "APPROVED";
                        resolve(data);
                    })
                    .catch((response) => {
                        reject(response);
                    });
            });
        },
        showGrandTotalPrice(item) {
            let item_total_price = parseFloat(item.total_price);
            let item_decoration_fee = parseFloat(
                item.order_review_items[0].total_decoration_fee
            );
            let order_decoration_fee = this.order.OrderReviewFee.decoration_fee
                ? parseFloat(this.order.OrderReviewFee.decoration_fee)
                : 0;
            let total_design_fee =
                parseInt(item.total_quantity) *
                (item_decoration_fee + order_decoration_fee);
            item_total_price = item_total_price + total_design_fee;
            return parseFloat(item_total_price).toFixed(2);
        },
        onChangeVersionApproval(version_id) {
            if (version_id) {
                this.version = version_id;
            }
        }
    }
};
</script>
<style>
.section_to_print {
    display: none;
}
@media print {
    .no-print,
    .no-print * {
        display: none !important;
    }
    .section_to_print {
        display: block !important;
    }

    * {
        size: A4;
        -webkit-print-color-adjust: exact !important; /* Chrome, Safari 6 – 15.3, Edge */
        color-adjust: exact !important; /* Firefox 48 – 96 */
    }
}
</style>
